import { useState, useEffect } from 'react';

import {
  WIX_ADS_ELEMENT_ID,
  FREE_TIER_BANNER_DEFAULT_HEIGHT_PX,
} from '../../../utils/constants';

export const useFreeTierBannerHeight = (isPremium: boolean): number => {
  const [height, setHeight] = useState(() =>
    getFreeTierBannerHeight(isPremium),
  );

  useEffect(() => {
    if (isPremium) {
      setHeight(0);

      return;
    }

    const el = document.getElementById(WIX_ADS_ELEMENT_ID);

    if (!el) {
      return;
    }

    const observer = new ResizeObserver(() => {
      setHeight(el.getBoundingClientRect().height);
    });

    observer.observe(el);

    return () => observer.disconnect();
  }, [isPremium]);

  return height;
};

function getFreeTierBannerHeight(isPremium: boolean) {
  if (isPremium || typeof window === 'undefined') {
    return 0;
  }

  const el = document.getElementById(WIX_ADS_ELEMENT_ID);

  return el
    ? el.getBoundingClientRect().height
    : FREE_TIER_BANNER_DEFAULT_HEIGHT_PX;
}
